module.exports = "https://web-assets-production.autolist.com/_next/static/images/suv-angled-e42eeaee2d57110888ebfffb4fa68d5f.jpg";